import React, { useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import {
  handleSentimentHighlight,
  getProcessedTextPreview,
} from "../../../utilities/NewsUtilities";
import { formatDisplayDate } from "../../../utilities/CommonUtilities";

const NewsDetail = ({ news, onClose }) => {
  const [highlightedArticle, setHighlightedArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const displayDate = formatDisplayDate(new Date(news.data_timestamp));
  const title =
    news.document_name !== null
      ? news.document_name
      : getProcessedTextPreview(news.processed_text, 100);
  const source_url = news.public_data_source_url;
  const news_article = news.processed_text;
  const relevanceIndicator = (() => {
    const score = news.ner_relevance_score;
    if (score > 0.5) {
      return {
        color: "green",
        icon: <i className="fa-solid fa-caret-up" />,
        title: "High Relevance",
      };
    } else if (score > 0) {
      return {
        color: "#ffc107",
        icon: <i className="fa-solid fa-xs fa-circle" />,
        title: "Moderate Relevance",
      };
    } else {
      return {
        color: "red",
        icon: <i className="fa-solid fa-caret-down" />,
        title: "Low Relevance",
      };
    }
  })();
  const handleClose = () => {
    setHighlightedArticle(null);
    onClose();
  };

  const toggleHighlight = async () => {
    setIsLoading(true);
    highlightedArticle
      ? setHighlightedArticle(null)
      : await handleSentimentHighlight(news_article, setHighlightedArticle);
    setIsLoading(false);
  };

  return (
    <Modal show onHide={handleClose} size="xl" centered enforceFocus={false}>
      <Modal.Header className="bg-light" closeButton>
        <div className="w-100">
          <div className="text-start">
            <Modal.Title>{title}</Modal.Title>
            <div className="d-flex justify-content-start align-items-center text-muted gap-2 mb-2">
              <div>
                <a
                  href={source_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted "
                >
                  <i className="fa-solid fa-globe" /> Source
                </a>
              </div>
              |
              <div>
                <i className="fa-regular fa-calendar me-2" />
                {displayDate}
              </div>
              {news.ner_relevance_score ? (
                <div>
                  {" "}
                  | Relevance :
                  <span
                    style={{
                      color: relevanceIndicator.color,
                      fontSize: "15px",
                    }}
                    title={relevanceIndicator.title}
                    className="ms-2"
                  >
                    {relevanceIndicator.icon}
                    {"  "}
                    {news.ner_relevance_score}
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="d-flex justify-content-start align-items-center text-muted">
            {news.translated_document_name
              ? `Translation:  ${news.translated_document_name}`
              : ""}
          </div>
        </div>
      </Modal.Header>
      <Modal.Body
        className="custom-scroll"
        style={{ maxHeight: "calc(100vh - 300px)", overflowY: "scroll" }}
      >
        {highlightedArticle ? (
          <div dangerouslySetInnerHTML={{ __html: highlightedArticle }} />
        ) : (
          <p>{news_article}</p>
        )}
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <Button
          onClick={toggleHighlight}
          variant={isLoading || highlightedArticle ? "secondary" : "primary"}
        >
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Processing...
            </>
          ) : highlightedArticle ? (
            "Revert Highlight"
          ) : (
            "Highlight Sentiment"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewsDetail;
